(() => {
  if (window.__lpSingleGalleryCompatGuard) return;
  window.__lpSingleGalleryCompatGuard = true;
  let queued = false;
  const sync = () => {
    queued = false;
    const roots = document.querySelectorAll('media-gallery,product-media-gallery');
    roots.forEach(root => {
      const previews = [...root.querySelectorAll('.lp-pdp-preview')];
      if (!previews.length) return;
      const current = previews.find(preview => preview.closest('.product__media-item')?.classList.contains('lp-personalised-gallery-owner')) || previews.at(-1);
      const owner = current?.closest('.product__media-item');
      root.querySelectorAll('.product__media-item').forEach(item => {
        const isOwner = item === owner;
        item.classList.toggle('lp-personalised-gallery-owner', isOwner);
        const display = isOwner ? 'list-item' : 'none';
        if (item.style.getPropertyValue('display') !== display || item.style.getPropertyPriority('display') !== 'important') item.style.setProperty('display', display, 'important');
        if (isOwner) {
          if (item.style.getPropertyValue('opacity') !== '1') item.style.setProperty('opacity', '1', 'important');
          if (item.style.getPropertyValue('visibility') !== 'visible') item.style.setProperty('visibility', 'visible', 'important');
        }
      });
      previews.forEach(preview => {
        if (preview === current) return;
        const media = preview.closest('.product__media');
        media?.querySelectorAll('.lp-pdp-gallery-controls').forEach(control => control.remove());
        preview.remove();
      });
    });
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(sync);
  };
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','style'] });
  document.addEventListener('change', event => {
    if (!event.target.matches('input[data-option-name="Colour"],select')) return;
    [0, 30, 100, 300, 800, 1500].forEach(delay => setTimeout(sync, delay));
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  /* lp-single-gallery-compat-guard-v1-2026-08-06 */
})();
